import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_PETITION_MEDIA_HIT_DIGEST_CONFIG = defineFcm('lcm_petition_media_hit_digest_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				workflow_id: { type: 'number' },
				list_id: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms_stack',
		description: 'Used to configure petition media hit digests to be sent through Iterable',
		template: {
			workflow_id: 1234,
			list_id: 5678,
		},
	});
